export const makeArrayUnique = (arr: any[]) => {
  let mapObj = new Map(arr.map((obj) => {
    return [JSON.stringify(obj), obj];
  }));
  let output = Array.from(mapObj.values());
  return output;
}